import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-center" }
const _hoisted_2 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "d-block font-weight-bold" }, "No items found…", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "row gx-0" }
const _hoisted_9 = { class: "col-lg-2 pe-lg-1" }
const _hoisted_10 = { class: "ce-event-calendar-item-label" }
const _hoisted_11 = { class: "ce-event-calendar-item-date" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "col-lg-3" }
const _hoisted_15 = { class: "ce-event-calendar-item-label" }
const _hoisted_16 = ["href", "target"]
const _hoisted_17 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_18 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_19 = { class: "col-lg-2 ps-lg-2" }
const _hoisted_20 = { class: "ce-event-calendar-item-label" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = {
  key: 0,
  class: "text-uppercase"
}
const _hoisted_23 = { class: "col-lg-2 ps-lg-2" }
const _hoisted_24 = { class: "ce-event-calendar-item-label" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-lg-3 ps-lg-2 d-lg-flex justify-content-between" }
const _hoisted_27 = { class: "ce-event-calendar-item-label" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "filter", { filter: _ctx.filter }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _withDirectives(_createElementVNode("div", _hoisted_2, _hoisted_4, 512), [
            [_vShow, _ctx.isLoading]
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (!_ctx.isLoading && !_ctx.filteredItems.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "header"),
    _createVNode(_TransitionGroup, {
      tag: "div",
      name: "arrange"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (event) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ce-event-calendar-item arrange-item",
            key: event.uid
          }, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.props.date), 1),
                _createElementVNode("span", _hoisted_11, [
                  (event.dateFrom)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.convertDate(event.dateFrom)), 1))
                    : _createCommentVNode("", true),
                  (event.dateTo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " - " + _toDisplayString(_ctx.convertDate(event.dateTo)), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("strong", _hoisted_15, _toDisplayString(_ctx.props.title), 1),
                (event.link.link)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: event.link.link,
                      target: event.link.target
                    }, [
                      (event.title)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(event.title), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_16))
                  : (event.title)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(event.title), 1))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("strong", _hoisted_20, _toDisplayString(_ctx.props.cityCountry), 1),
                (event.city)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                      _createTextVNode(_toDisplayString(event.city), 1),
                      (event.country)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_22, ", " + _toDisplayString(event.country), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("strong", _hoisted_24, _toDisplayString(_ctx.props.additional), 1),
                (event.additional)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(event.additional), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("strong", _hoisted_27, _toDisplayString(_ctx.props.portfolio), 1),
                (event.portfolio)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.portfolioJoin(event.portfolio)), 1))
                  : _createCommentVNode("", true),
                (event.iCalLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: event.iCalLink,
                      class: "ce-event-calendar-item-icon"
                    }, [
                      _createVNode(_component_inline_svg, {
                        src: require('@dw_boilerplate/Partials/Icons/Calendar.svg')
                      }, null, 8, ["src"])
                    ], 8, _hoisted_29))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}